import L from 'leaflet';

const invalidateSize = ( map ) => {
	setTimeout( function() {
		map.invalidateSize();
	}, 0 );
};

const getMapBounds = ( mapDataProperties ) => {
	const mapBounds = [];
	for ( let i = 0; i < mapDataProperties.length; i++ ) {
		if ( mapDataProperties[ i ].lat_lon.lat && mapDataProperties[ i ].lat_lon.lon ) {
			mapBounds.push( [ mapDataProperties[ i ].lat_lon.lat, mapDataProperties[ i ].lat_lon.lon ] );
		}
	}

	return mapBounds;
};

const addMarker = ( properties, map ) => {
	for ( let i = 0; i < properties.length; i++ ) {
		if ( properties[ i ].lat_lon.lat && properties[ i ].lat_lon.lon ) {
			const lat = properties[ i ].lat_lon.lat;
			const lon = properties[ i ].lat_lon.lon;
			let { title, thumbnail, permalink, price } = properties[ i ];
			const textAfterPrice = properties[ i ].text_after_price;
			const typeName = properties[ i ].type_name;
			const typeLink = properties[ i ].type_link;
			if ( ! thumbnail ) {
				thumbnail = REALPRESS_GLOBAL_OBJECT.image_placeholder;
			}
			const propertyId = properties[ i ].property_id;

			const mapCenter = L.latLng( lat, lon );

			const markerOptions = {
				riseOnHover: true,
			};

			if ( title ) {
				markerOptions.title = title;
			}

			const marker = L.marker( mapCenter, markerOptions ).addTo( map );

			let popup = `<div class="realpress-popup-property-header">
						<a target="_blank" href="${ permalink }"><img src="${ thumbnail }" alt="#"></a>
					</div>
					<div class="realpress-popup-property-body">
						<h2><a target="_blank" href="${ permalink }">${ title }</a></h2>
						<div class="realpress-popup-property-price">
							<span>${ price }</span>&nbsp;<span>${ textAfterPrice }</span>
						</div>`;
			if ( typeName && typeLink ) {
				popup += `<div class="realpress-popup-type"><a target="_blank" href="${ typeLink }">${ typeName }</a></div>`;
			}
			popup += `</div>`;
			//Set id for marker
			marker.id = propertyId;
			marker.bindPopup( popup );
		}
	}
};

const openPopup = ( map, propertyId ) => {
	if ( ! map ) {
		return;
	}

	map.eachLayer( function( layer ) {
		if ( layer.id === parseInt( propertyId ) ) {
			layer.openPopup();
		}
	} );
};

const closePopup = ( map, propertyId ) => {
	if ( ! map ) {
		return;
	}

	map.eachLayer( function( layer ) {
		if ( layer.id === parseInt( propertyId ) ) {
			layer.closePopup();
		}
	} );
};

export { invalidateSize, getMapBounds, addMarker, openPopup, closePopup };
